module.exports = __webpack_public_path__ + "img/eoi-hero_en.6254698.jpg";